import { useState } from 'react';

// eslint-disable-next-line
export const ToggleBooleanState = (initialState = false) => {
  const [state, setState] = useState(initialState);

  const toggleState = (value?: boolean) => {
    if (typeof value === 'boolean') {
      setState(value);
    } else {
      setState(!state);
    }
  };

  return [state, toggleState] as [boolean, (value?: boolean) => void];
};
